import YTMusic from "./YTMusic"

export type {
	AlbumBasic,
	AlbumDetailed,
	AlbumFull,
	ArtistBasic,
	ArtistDetailed,
	ArtistFull,
	PlaylistDetailed,
	PlaylistFull,
	SearchResult,
	SongDetailed,
	SongFull,
	ThumbnailFull,
	VideoDetailed,
	VideoFull,
	HomeSection,
} from "./types"

export default YTMusic
